export default "__VITE_ASSET__CX55lDMT__"